import { Controller } from "@hotwired/stimulus"
import Lottie from "lottie-web/build/player/lottie_svg"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { animationUrl: String }

  initialize() {
    this.animation = null
    this.allPlanets = [
      "ivd",
      "controls",
      "cell",
      "antigen",
      "services"
    ]
  }

  connect() {
    this.loadLottieAnimation()
  }

  disconnect() {
    if (this.animation) {
      this.animation.destroy()
    }
  }

  loadLottieAnimation() {
    this.animation = Lottie.loadAnimation({
      container: this.canvasTarget,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: this.animationUrlValue,
    })
  }

  mouseenter(event) {
    const planet = event.currentTarget.dataset.planet

    let remainingPlanets = this.allPlanets.filter(p => p !== planet)

    remainingPlanets.forEach(p => {
      const elements = document.querySelectorAll(`.${p}`)
      elements.forEach(element => {
        element.classList.add("inactive")
      })
    })

    let planetElements = document.querySelectorAll(`.${planet}`)
    planetElements.forEach(element => {
      element.classList.remove("inactive")
    })
  }

  mouseleave() {
    this.allPlanets.forEach(p => {
      const elements = document.querySelectorAll(`.${p}`)
      elements.forEach(element => {
        element.classList.remove("inactive")
      })
    })
  }
}
